'use client'
import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/lib/auth-context'
import { loginRequest } from '@/lib/api'

export default function LoginPage() {
  const router = useRouter()
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPw, setShowPw] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<{email?:string;password?:string;general?:string}>({})

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const errs: {email?:string;password?:string} = {}
    if (!email || !/\S+@\S+\.\S+/.test(email)) errs.email = 'Ingresa un correo válido'
    if (!password) errs.password = 'La contraseña es requerida'
    if (Object.keys(errs).length) { setErrors(errs); return }
    setErrors({})
    setLoading(true)

    try {
      const data = await loginRequest(email, password)
      login(data.token, data.user)
      router.push('/inicio')
    } catch (err: any) {
      setErrors({ general: err.message || 'Correo o contraseña incorrectos' })
      setLoading(false)
    }
  }

  return (
    <div className="login-grid" style={{display:'grid',gridTemplateColumns:'1.3fr 1fr',minHeight:'100vh',fontFamily:'Inter,sans-serif'}}>

      {/* IZQUIERDO — Imagen de viaje + overlay morado */}
      <div className="login-hero" style={{
        background:`linear-gradient(135deg,rgba(13,13,26,.88) 0%,rgba(26,11,46,.85) 60%,rgba(41,18,64,.9) 100%), url('/travel_login.jpg')`,
        backgroundSize:'cover',
        backgroundPosition:'center',
        display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'56px 48px',position:'relative',overflow:'hidden'
      }}>
        <div className="login-ring" style={{position:'absolute',width:'400px',height:'400px',borderRadius:'50%',border:'1px solid rgba(114,194,191,.1)',top:'50%',left:'50%',transform:'translate(-50%,-50%)',animation:'rotate 20s linear infinite'}}></div>
        <div className="login-ring" style={{position:'absolute',width:'550px',height:'550px',borderRadius:'50%',border:'1px solid rgba(254,9,85,.06)',top:'50%',left:'50%',transform:'translate(-50%,-50%)',animation:'rotate 30s linear infinite reverse'}}></div>
        <div style={{textAlign:'center',zIndex:2,position:'relative'}}>
          <div className="login-hero-kicker" style={{fontSize:'11px',fontWeight:'600',letterSpacing:'.14em',textTransform:'uppercase',color:'#72c2bf',marginBottom:'14px'}}>Bienvenido al sistema</div>
          <div className="login-hero-title" style={{fontSize:'38px',fontWeight:'700',color:'#fff',lineHeight:1.1,letterSpacing:'-1px',marginBottom:'18px'}}>Tu panel de<br/>gestión <span style={{color:'#fe0955'}}>todo en uno</span></div>
          <div className="login-hero-sub" style={{fontSize:'14px',fontWeight:'300',color:'rgba(255,255,255,.55)',lineHeight:1.7,maxWidth:'320px',margin:'0 auto'}}>Controla conversaciones, ventas y operaciones.</div>
        </div>
        <style>{`@keyframes rotate{to{transform:translate(-50%,-50%) rotate(360deg)}}
          /* ── Vista móvil / tablet vertical ── */
          @media (max-width: 900px) {
            .login-grid { grid-template-columns: 1fr !important; }
            .login-hero { padding: 28px 24px !important; min-height: 150px; }
            .login-ring, .login-hero-kicker, .login-hero-sub { display: none !important; }
            .login-hero-title { font-size: 26px !important; margin-bottom: 0 !important; letter-spacing: -.5px !important; }
            .login-form-wrap { padding: 28px 20px 40px !important; align-items: flex-start !important; }
            .login-logo { margin-bottom: 24px !important; }
            .login-heading { font-size: 22px !important; }
            .login-intro { margin-bottom: 24px !important; }
            /* 16px evita que el iPhone haga zoom automático al tocar el campo */
            .login-input { font-size: 16px !important; }
          }
          @media (prefers-reduced-motion: reduce) {
            .login-ring { animation: none !important; }
          }`}</style>
      </div>

      {/* DERECHO — Login */}
      <div className="login-form-wrap" style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'48px 56px',background:'#f7f7f9'}}>
        <div style={{width:'100%',maxWidth:'400px'}}>

          {/* Logo */}
          <div className="login-logo" style={{marginBottom:'40px'}}>
            <img src="/logo_crm.jpeg" alt="ISA Chat · Bella Center"
              style={{width:'100%',height:'auto',borderRadius:'10px',display:'block'}}/>
          </div>

          <div style={{fontSize:'11px',fontWeight:'600',letterSpacing:'.12em',textTransform:'uppercase',color:'#72c2bf',marginBottom:'8px'}}>Acceso seguro</div>
          <div className="login-heading" style={{fontSize:'26px',fontWeight:'700',color:'#291240',letterSpacing:'-.5px',marginBottom:'6px'}}>Bienvenido de nuevo</div>
          <div className="login-intro" style={{fontSize:'13px',color:'#999',marginBottom:'36px',lineHeight:1.5}}>Ingresa tus credenciales para acceder al panel de gestión.</div>

          {errors.general && (
            <div style={{background:'#fff0f5',border:'1px solid rgba(254,9,85,.2)',borderRadius:'8px',padding:'12px 14px',marginBottom:'20px',fontSize:'13px',color:'#fe0955',fontWeight:'500'}}>
              ⚠️ {errors.general}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:'18px'}}>
              <label style={{display:'block',fontSize:'11px',fontWeight:'600',color:'#555',letterSpacing:'.06em',textTransform:'uppercase',marginBottom:'7px'}}>Correo electrónico</label>
              <div style={{position:'relative'}}>
                <span style={{position:'absolute',left:'14px',top:'50%',transform:'translateY(-50%)',color:'#bbb',fontSize:'15px'}}>✉</span>
                <input className="login-input" type="email" value={email} onChange={e=>{setEmail(e.target.value);setErrors({})}}
                  placeholder="usuario@grupostravel.com"
                  style={{width:'100%',boxSizing:'border-box',height:'50px',padding:'0 14px 0 42px',border:`1.5px solid ${errors.email?'#fe0955':'#e2e2e8'}`,borderRadius:'10px',fontSize:'14px',color:'#1a1a2e',background:'#fff',outline:'none',fontFamily:'inherit',transition:'border-color .2s'}}
                />
              </div>
              {errors.email && <div style={{fontSize:'11px',color:'#fe0955',marginTop:'5px',fontWeight:'500'}}>{errors.email}</div>}
            </div>

            <div style={{marginBottom:'18px'}}>
              <label style={{display:'block',fontSize:'11px',fontWeight:'600',color:'#555',letterSpacing:'.06em',textTransform:'uppercase',marginBottom:'7px'}}>Contraseña</label>
              <div style={{position:'relative'}}>
                <span style={{position:'absolute',left:'14px',top:'50%',transform:'translateY(-50%)',color:'#bbb',fontSize:'15px'}}>🔒</span>
                <input className="login-input" type={showPw?'text':'password'} value={password} onChange={e=>{setPassword(e.target.value);setErrors({})}}
                  placeholder="••••••••"
                  style={{width:'100%',boxSizing:'border-box',height:'50px',padding:'0 44px 0 42px',border:`1.5px solid ${errors.password?'#fe0955':'#e2e2e8'}`,borderRadius:'10px',fontSize:'14px',color:'#1a1a2e',background:'#fff',outline:'none',fontFamily:'inherit',transition:'border-color .2s'}}
                />
                <button type="button" onClick={()=>setShowPw(!showPw)}
                  style={{position:'absolute',right:'12px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'#bbb',fontSize:'15px'}}>
                  {showPw?'🙈':'👁'}
                </button>
              </div>
              {errors.password && <div style={{fontSize:'11px',color:'#fe0955',marginTop:'5px',fontWeight:'500'}}>{errors.password}</div>}
            </div>

            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'28px'}}>
              <label style={{display:'flex',alignItems:'center',gap:'8px',cursor:'pointer',fontSize:'13px',color:'#777'}}>
                <input type="checkbox" style={{accentColor:'#fe0955'}}/>
                Recordar sesión
              </label>
              <a href="#" style={{fontSize:'13px',color:'#325a59',textDecoration:'none',fontWeight:'500'}}>¿Olvidaste tu contraseña?</a>
            </div>

            <button type="submit" disabled={loading}
              style={{width:'100%',height:'52px',background: loading ? '#4a2a6e' : '#291240',color:'#fff',border:'none',borderRadius:'10px',fontSize:'15px',fontWeight:'600',cursor: loading ? 'not-allowed' : 'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',fontFamily:'inherit',transition:'background .2s'}}>
              {loading ? '⏳ Verificando credenciales...' : 'Ingresar al panel →'}
            </button>
          </form>

          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',marginTop:'28px'}}>
            <div style={{width:'7px',height:'7px',borderRadius:'50%',background:'#72c2bf',animation:'pulse 2s infinite'}}></div>
            <span style={{fontSize:'12px',color:'#bbb'}}>Todos los servicios operativos · v2.0</span>
          </div>
          <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
        </div>
      </div>
    </div>
  )
}
